import _cloneDeep from 'lodash/cloneDeep'
import _isEqual from 'lodash/isEqual'

const pointListForUI = (currentPointList, initialPointList) => {
  const pointListForUI = _cloneDeep(currentPointList)
  // current の要素全てにアクセスし、
  currentPointList.forEach(currentPoint => {
    // POIの時
    if (!('id' in currentPoint)) return
    // id が一致する initialPoint を見つける
    const correspondingInitialPoint = initialPointList.find(initialPoint => {
      if (currentPoint.id || currentPoint.id === null) {
        return initialPoint.id === currentPoint.id
      }
      return _isEqual(initialPoint, currentPoint)
    })
    // 対応する UI 用の point を見つける
    const correspondingPointForUI = pointListForUI.find(pointForUI => {
      if (currentPoint.id || currentPoint.id === null) {
        return pointForUI.id === currentPoint.id
      }
      return _isEqual(pointForUI, currentPoint)
    })

    // そもそも correspondingInitialPoint がない
    // => つまり新規のポイント場合
    if (!correspondingInitialPoint) {
      correspondingPointForUI.updated = true
      return
    }

    // 内容が同じかどうかをチェックする
    const isNotUpdated = _isEqual(currentPoint, correspondingInitialPoint)
    // 変更された状態かどうかを値として保持する
    correspondingPointForUI.updated = !isNotUpdated
  })
  return pointListForUI
}

export default pointListForUI
